import { render } from "./AffiliatePayments.vue?vue&type=template&id=c2e5adf4"
import script from "./AffiliatePayments.vue?vue&type=script&lang=js"
export * from "./AffiliatePayments.vue?vue&type=script&lang=js"

import "./AffiliatePayments.vue?vue&type=style&index=0&id=c2e5adf4&lang=scss"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__